module.exports = __webpack_public_path__ + "img/building-02.4a4f485a.svg";